// The SPA talks to exactly one thing: the Veralis BFF (gateway). The BFF is the
// MCP client that fronts the engines. See ../../doc/decision-bff.md.
//
// Two deployments, two answers (plan-public-access P2):
//
//   dev    — SPA on :5173, BFF on :8787. Absolute and derived from the page
//            host, so localhost AND the LAN both work
//            (http://192.168.0.237:5173 -> http://192.168.0.237:8787).
//   build  — served same-origin behind Caddy, so the API base is EMPTY and
//            every call is a relative path. This is not tidiness: the session
//            cookie is SameSite=Lax, and one origin is what keeps it a plain
//            first-party cookie instead of needing SameSite=None.
//
// VITE_BFF_URL overrides both (set it explicitly, including to '', to pin the
// base — e.g. `npm run preview`, which serves the production build from the
// Vite server rather than from Caddy).
const DEV_FALLBACK =
  typeof window !== 'undefined'
    ? `${window.location.protocol}//${window.location.hostname}:8787`
    : 'http://localhost:8787'

export const BFF_URL =
  import.meta.env.VITE_BFF_URL != null
    ? import.meta.env.VITE_BFF_URL
    : import.meta.env.PROD
      ? ''
      : DEV_FALLBACK

// Absolute origin of the API — for links and copy-paste instructions shown to
// the user, where a relative base has to be spelled out as a real URL. An empty
// BFF_URL means "same origin as this page".
export const BFF_ORIGIN =
  BFF_URL || (typeof window !== 'undefined' ? window.location.origin : '')

// The three engine areas the shell renders. `status` gates which are wired.
export const ENGINES = {
  rag: {
    key: 'rag',
    label: 'Search',
    blurb: 'Ask your archive — semantic search across your indexed documents.',
    status: 'live',
  },
  transcribe: {
    key: 'transcribe',
    label: 'Transcription',
    blurb: 'Turn audio and video into searchable, structured transcripts.',
    status: 'planned',
  },
  t8r: {
    key: 't8r',
    label: 'Translation',
    blurb: 'Translate documents across languages without losing meaning.',
    status: 'planned',
  },
}

export default ENGINES
